import { App } from "./components";
import "bootstrap/dist/css/bootstrap.css";
import "./style.css";

export default App;
